import a from "./atoms-v21053.js";
function t(r) {
  if (Array.isArray(r))
    return a(r);
}
export {
  t as default
};
